export const landing_page_email_form_submitted =
  'Landing Page Email Form - Submitted';
